import { Box, Grid } from '@material-ui/core'
import React from 'react'

const OpenNote = () => {
  return (
    <Grid container>
        <Grid item xs={12} sx={{bgcolor:'primary.light'}}>
            <Box sx={{boxShadow:3}}>ooP</Box>
        </Grid>
    </Grid>
    )
}

export default OpenNote